// Calendar-date helpers. The backend returns DATE columns (deal start/end dates,
// payment due dates) as plain 'YYYY-MM-DD' strings — parsing those with
// `new Date(str)` pins them to UTC midnight, which renders as the *previous day*
// for any viewer west of UTC. These helpers parse date-only strings as local
// dates so they display as the calendar day they are.

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

// Date-only strings → local Date at midnight; anything else → normal Date parse.
export function parseDate(value) {
  if (value == null || value === '') return null;
  const m = DATE_ONLY.exec(String(value));
  if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  return new Date(value);
}

export function fmtDate(value, opts = { month: 'short', day: 'numeric', year: 'numeric' }) {
  const d = parseDate(value);
  return d ? d.toLocaleDateString('en-US', opts) : '';
}

// Lot timezones (IANA ids) — a deal's bidding stays open through the end of its
// end date in the seller lot's zone.
export const US_TIMEZONES = [
  { id: 'Pacific/Honolulu',    label: 'Hawaii (HST)' },
  { id: 'America/Anchorage',   label: 'Alaska (AKT)' },
  { id: 'America/Los_Angeles', label: 'Pacific (PT)' },
  { id: 'America/Phoenix',     label: 'Arizona (MST)' },
  { id: 'America/Denver',      label: 'Mountain (MT)' },
  { id: 'America/Chicago',     label: 'Central (CT)' },
  { id: 'America/New_York',    label: 'Eastern (ET)' },
];
